enum UserDefinedObjectEntity {
	PROJECT = 1,
	CLIENT = 4,
	CONTACT = 6
}

export default UserDefinedObjectEntity;
